import React, { useState } from "react";
import { Table,Divider } from "antd";
import { WITHDRAWAL_TYPE_REVERSE } from "@/constants/util";

const Content = (props) => {

  const { dataSource,page,onTableChange=()=>{},onShowSizeChange=()=>{},onEdit=()=>{} }=props;

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columns=[
    {
      title: '提现时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '提现人员',
      dataIndex: 'employeesName',
      key: 'employeesName',
    },
    {
      title: '提现方式',
      dataIndex: 'mode',
      key: 'mode',
      render:(text)=>{
        return WITHDRAWAL_TYPE_REVERSE[text]
      }
    },
    {
      title: '提现金额/元',
      dataIndex: 'amount',
      key: 'amount',
    }, 
    {
      title: '账户余额/元',
      dataIndex: 'balance',
      key: 'balance',
    }
  ]

  return (
    <div className="bg-white">
      <Table
        rowSelection={false}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      /> 
    </div>
  );
};

export default Content;
